import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AvanceSegComponent } from './avance-seg/avance-seg.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { PlanEstrategicoComponent } from './plan-estrategico/plan-estrategico.component';

const routes: Routes = [
  {
    path: 'app/reportes',
    component: ContenedorComponent,
    children: [
      {path: 'avance-seguimiento', component: AvanceSegComponent, canActivate: [authGuardSubmodule]},
      {path: 'plan-estrategico', component: PlanEstrategicoComponent, canActivate: [authGuardSubmodule]},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportesRoutingModule { }
